jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('click', '.tabs button', function () {
        let tab_id = $(this).data('id');
        let tab_content = $('.single-tab[data-id*=' + tab_id + ']');
        let tab_content_image = $('.single-tab-image[data-id*=' + tab_id + ']');

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        tab_content.siblings().hide();
        tab_content.fadeIn();
        tab_content.css('display', 'flex');

        tab_content_image.siblings().removeClass('active');
        tab_content_image.addClass('active');

    });

});